import React from "react";
import Page, { PageProps } from "../Page";
import NoticeList from "../portal/NoticeList";
import { IPortalHomePresenter } from "../../../presenter/portal/PortalHomePresenter";

export interface Props extends PageProps {}
export interface State extends IPortalHomePresenter {}

export default class PortalHomePage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe(result => {
      return this.setState(prevState => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const { noticeList, translate } = this.state;
    return (
      <Page {...this.props}>
        <NoticeList noticeList={noticeList} translate={translate} />
      </Page>
    );
  }
}
